var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 7.6875C21 7.87083 20.8906 8.07083 20.6719 8.2875L16.0907 12.7125L17.1761 18.9625C17.1845 19.0208 17.1887 19.1042 17.1887 19.2125C17.1887 19.3875 17.1445 19.5354 17.0562 19.6563C16.9678 19.7771 16.8395 19.8375 16.6713 19.8375C16.5114 19.8375 16.3431 19.7875 16.1665 19.6875L10.5 16.7375L4.83353 19.6875C4.64844 19.7875 4.48017 19.8375 4.32873 19.8375C4.15204 19.8375 4.01953 19.7771 3.93119 19.6563C3.84285 19.5354 3.79868 19.3875 3.79868 19.2125C3.79868 19.1625 3.80709 19.0792 3.82392 18.9625L4.90925 12.7125L0.315505 8.2875C0.105168 8.0625 0 7.8625 0 7.6875C0 7.37917 0.235577 7.1875 0.706731 7.1125L7.04207 6.2L9.88161 0.5125C10.0415 0.170833 10.2476 0 10.5 0C10.7524 0 10.9585 0.170833 11.1184 0.5125L13.9579 6.2L20.2933 7.1125C20.7644 7.1875 21 7.37917 21 7.6875Z",
    fill: "#FFCA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.d11a26121c2864ca409e64a15e01308e.svg";
export { ForwardRef as ReactComponent };